import React, { useContext } from 'react';
import I18n from 'i18n-js';

import { MParticleEventName, trackEvent } from '@reverbdotcom/commons/src/elog/mparticle_tracker';
import { RCMenu } from '@reverbdotcom/cadence/components';
import AutoOfferModal from '../../listings/auto_offer_modal';
import SellerListingsCollectionContext from '../SellerListingsCollectionContext';

interface AutoOfferModalButtonV2Props {
  listingId: string;
  offerActive: boolean;
  setShowModal: (isOpen) => void;
}

export const COMPONENT_NAME = 'AutoOfferModalButtonV2';

export function AutoOfferModalButtonV2({
  listingId,
  offerActive,
  setShowModal,
}: AutoOfferModalButtonV2Props) {
  function handleClick() {
    setShowModal(true);
    trackEvent({
      eventName: MParticleEventName.ClickedComponent,
      componentName: COMPONENT_NAME,
      listingId,
    });
  }

  return (
    <RCMenu.Item onClick={handleClick}>
      {offerActive && (I18n.t('discovery.listingsManagement.sellerListingCard.offers.autoOffers.autoOffersManage'))}
      {!offerActive && (I18n.t('discovery.listingsManagement.sellerListingCard.offers.autoOffers.autoOffersEnable'))}
    </RCMenu.Item>
  );
}

interface AutoOfferModalV2Props {
  listingId: string;
  showModal: boolean;
  setShowModal: (isOpen) => void;
}

export function AutoOfferModalV2({
  listingId,
  showModal,
  setShowModal,
}: AutoOfferModalV2Props) {
  const { useLazySellerListingsQuery } = useContext(SellerListingsCollectionContext);
  const { refetchSellerListings } = useLazySellerListingsQuery();

  if (showModal) {
    return (
      <AutoOfferModal
        modalIsOpen={showModal}
        listingId={listingId}
        onModalClose={() => setShowModal(false)}
        refetchSellerListing={() => refetchSellerListings([listingId]) }
      />
    );
  }

  return null;
}
